import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function DatapointsExportModalHeader({ parentParams, selectedDatapoints, close }) {
  const { context } = parentParams; // replaceCitations
  const { count } = selectedDatapoints;
  const closeLabel = 'Close export modal';

  return (
    <div className="exportModal__header datapointsExportModal__header">
      <h3 className="u-els-font-size-h3 u-els-line-height-single">
        Export <span className="text-lowercase">{context}</span>
        {!!count && <span> {count}</span>}
      </h3>
      <ButtonWithIcon
        data-e2e="datapoints-export-modal-header-close"
        type="link"
        size="small"
        sprite="Close"
        iconOnly
        aria-label={closeLabel}
        onClick={close}>
        {closeLabel}
      </ButtonWithIcon>
    </div>
  );
}

DatapointsExportModalHeader.propTypes = {
  parentParams: PropTypes.object,
  selectedDatapoints: PropTypes.object,
  close: PropTypes.func.isRequired,
};

export default DatapointsExportModalHeader;
